import { sonic as viemSonic } from 'viem/chains';

import { getContrastColor } from '@infinex/ui-utils/color';

import { envOverrides } from '../../env';
import {
  DEFAULT_CHAIN_LIMITS,
  defaultEnvironments,
  defaultServices,
  defaultSwidge,
} from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const sonic = {
  displayName: 'Sonic',
  runtime: 'evm',
  viemChain: viemSonic,
  isSupported: true,
  isReleased: true,
  isMainnet: true,
  orderPriority: 14,

  decoration: {
    color: '#F5F5F5',
    contrastColor: getContrastColor('#F5F5F5'),
  },
  features: {
    wallet: { supported: true, import: false },
    vault: {
      supported: true,
      ccqRecovery: true,
    },
  },
  connectivity: {
    rpc: { quicknode: { chainKey: 'sonic-mainnet' } },
    blockExplorers: {
      primary: {
        base: 'https://sonicscan.org',
        token: 'https://sonicscan.org/token',
      },
    },
  },
  environments: defaultEnvironments(true),
  swidge: defaultSwidge({
    debridge: {
      chainKey: '100000014',
      providerContract: '0x43dE2d77BF8027e25dBD179B491e8d64f38398aA',
    },
    lifi: { chainKey: 'SON' },
    stargate: { chainKey: 'sonic' },
    okx: { chainKey: '146' },
    kyberswap: { chainKey: 'sonic' },
  }),
  services: defaultServices({
    codex: {
      networkId: 146,
      nativeLiquidityAddress: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
    },
    defiLlama: { chainKeys: ['sonic'] },
    trm: { chainKey: 'sonic' },
    zerion: { chainKey: 'sonic' },
    coingecko: {
      networkId: 'sonic',
      platformId: 'sonic',
    },
    coingeckoDex: {
      networkId: 'sonic',
    },
    qnStreams: {
      networkKey: 'sonic-mainnet',
    },
    safe: { shortName: 'sonic' },
    pimlico: { chainSlug: 'sonic' },
  }),
  limits: envOverrides(DEFAULT_CHAIN_LIMITS, {}),
} as const satisfies AllChainConfig<'evm', true>;
